import { render, staticRenderFns } from "./RsaMagazzinoComponent.vue?vue&type=template&id=5295a9d7"
import script from "./RsaMagazzinoComponent.vue?vue&type=script&lang=js"
export * from "./RsaMagazzinoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports